import { memo } from 'react';

import EmailIconSVG from '@/assets/email-icon.svg?react';
import { Icon, IconProps } from '@/components/core';

const IEmailIcon = (props: Omit<IconProps, 'SVGComponent'>) => <Icon SVGComponent={EmailIconSVG} {...props} />;

export const EmailIcon = memo(IEmailIcon) as typeof IEmailIcon;
